<template>
  <div v-if="staffCallYn == true">
    <!-- layer -->
    <div class="dimed wrap">
      <div class="layer layer--bottom">
        <div class="layer__header fix-h">
          <div class="lyr-title">{{ $t('Modal.StaffCall.msg1') }}</div>
          <div class="ft-point">{{ $t('Modal.StaffCall.msg2') }}</div>
        </div>
        <div class="layer__body">
          <span class="img-area"><img :src="staffSrc" alt="" class="img-size" /></span>
        </div>
        <div class="layer__button">
          <button class="btn btn--cancel btn-anim" @mouseup="$emit('closeStaffCall')">{{ $t('Modal.StaffCall.msg5') }}</button>
          <button
            class="btn btn--submit btn-anim"
            @mouseup="
              staffCallAudio();
              $emit('setStaffCall');
            "
          >
            {{ $t('Modal.StaffCall.msg4') }}
          </button>
        </div>
      </div>
    </div>
    <!-- //layer -->
  </div>
</template>
<script>
import audioHelper from '@/js/common/audioHelper.js';

export default {
  name: 'staffCall',
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
      staffSrc: '',
    };
  },
  props: {
    staffCallYn: Boolean,
  },
  mounted() {
    if (this.$i18n.locale == 'jp') {
      this.staffSrc = require('@/assets/images/user/artwork_popup_staff_call_3d_jp.gif');
    } else if (this.$i18n.locale == 'ko') {
      this.staffSrc = require('@/assets/images/user/artwork_popup_staff_call_3d_ko.gif');
    } else if (this.$i18n.locale == 'en') {
      this.staffSrc = require('@/assets/images/user/artwork_popup_staff_call_3d_en.gif');
    } else if (this.$i18n.locale == 'cn') {
      this.staffSrc = require('@/assets/images/user/artwork_popup_staff_call_3d_zh_cn.gif');
    } else if (this.$i18n.locale == 'tw') {
      this.staffSrc = require('@/assets/images/user/artwork_popup_staff_call_3d_zh_tw.gif');
    }
  },
  methods: {
    staffCallAudio() {
      try {
        audioHelper.playAudio('00051', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
      } catch (ex) {
        console.error(ex);
      }
    },
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
    staffCallYn: function (val) {
      try {
        // 20230407 HSSHIN Audio 재생
        if (val) {
          audioHelper.playAudio('00055', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
        } else {
          audioHelper.stopAudio();
        }
      } catch (ex) {
        console.error(ex);
      }
    },
    '$i18n.locale'() {
      if (this.$i18n.locale == 'jp') {
        this.staffSrc = require('@/assets/images/user/artwork_popup_staff_call_3d_jp.gif');
      } else if (this.$i18n.locale == 'ko') {
        this.staffSrc = require('@/assets/images/user/artwork_popup_staff_call_3d_ko.gif');
      } else if (this.$i18n.locale == 'en') {
        this.staffSrc = require('@/assets/images/user/artwork_popup_staff_call_3d_en.gif');
      } else if (this.$i18n.locale == 'cn') {
        this.staffSrc = require('@/assets/images/user/artwork_popup_staff_call_3d_zh_cn.gif');
      } else if (this.$i18n.locale == 'tw') {
        this.staffSrc = require('@/assets/images/user/artwork_popup_staff_call_3d_zh_tw.gif');
      }
    },
  },
  updated() {
    this.$showButtonAnimation();
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style scoped></style>
